var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftKusama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M203.184 124.926L211.802 117.744M211.802 117.744L209.887 133.065L223.772 121.096L211.802 117.744Z",
    stroke: "#E6007A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.173 93.8047L123.706 100.029",
    stroke: "#E6007A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.554 183.816L107.427 192.435",
    stroke: "#E6007A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.511 107.634L195.651 88.5385L189.463 102.19M202.511 107.634L189.463 102.19M202.511 107.634L178.68 110.937L189.463 102.19",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.071 65.0838L145.43 67.8526L135.015 78.3404L128.071 65.0838Z",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M186.905 59.2504L203.79 54.3596L198.836 68.285L186.905 59.2504Z",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.472 162.271L218.313 173.108L204.12 177.233L204.472 162.271Z",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M214.675 94.6805L231.56 89.7897L226.606 103.715L214.675 94.6805Z",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2698 198.18L53.8031 180.465L60.0273 187.168M43.2698 198.18L60.0273 187.168M43.2698 198.18H59.0697M60.0273 187.168L76.306 195.307L59.0697 198.18M60.0273 187.168L59.0697 198.18",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3243 181.423L63.8576 164.186M63.8576 164.186L73.4333 151.259M63.8576 164.186L72.4758 175.199M73.4333 151.259L89.7121 171.847M73.4333 151.259L75.3485 166.58L72.4758 175.199M72.4758 175.199L83.9666 186.689M72.4758 175.199L89.7121 171.847M83.9666 186.689L89.7121 171.847M83.9666 186.689L104.076 182.859M83.9666 186.689L97.8514 193.871M89.7121 171.847L104.076 182.859M104.076 182.859L97.8514 193.871M104.076 182.859L120.354 190.998L97.8514 193.871",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2333 171.847L74.8697 165.623L64.8152 163.708",
    stroke: "#E6007A",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4333 151.738L84.9242 134.502M84.9242 134.502L91.6272 123.968M84.9242 134.502L94.0211 148.386M84.9242 134.502L93.0636 135.22M91.6272 123.968L103.597 138.332M91.6272 123.968L93.0636 135.22M103.597 138.332L116.524 153.653M103.597 138.332L94.0211 148.386M103.597 138.332L105.033 151.738M103.597 138.332L93.0636 135.22M116.524 153.653L130.888 165.623M116.524 153.653L102.639 160.835M116.524 153.653L115.088 162.75M116.524 153.653L105.033 151.738M130.888 165.623L138.548 175.198M130.888 165.623V180.465M130.888 165.623L117.482 171.847M130.888 165.623L115.088 162.75M138.548 175.198L159.615 185.732M138.548 175.198L130.888 180.465M159.615 185.732L181.16 183.817M159.615 185.732L130.888 180.465M130.888 180.465L117.482 171.847M130.888 180.465L142.857 188.126M117.482 171.847L102.639 160.835M117.482 171.847L115.088 162.75M102.639 160.835L94.0211 148.386M102.639 160.835L105.033 151.738M102.639 160.835L115.088 162.75M94.0211 148.386L105.033 151.738M94.0211 148.386L93.0636 135.22M103.118 107.69L120.833 82.314M103.118 107.69L123.706 100.508M103.118 107.69L113.651 119.659M120.833 82.314L123.706 100.508M120.833 82.314L136.154 91.8897L149.56 107.211L161.051 122.053L170.627 136.417L176.372 150.78L183.554 168.974L181.16 183.817M123.706 100.508L113.651 119.659M113.651 119.659L120.354 131.629M113.651 119.659L128.972 111.52M120.354 131.629L132.324 141.205L141.9 153.653M120.354 131.629L133.76 122.053M141.9 153.653L150.997 165.623M141.9 153.653L148.124 144.556M150.997 165.623L170.148 170.889M150.997 165.623L159.615 159.398L170.148 170.889M150.997 165.623L168.46 176.156M170.148 170.889L181.16 183.817M170.148 170.889L168.46 176.156M181.16 183.817L168.46 176.156M141.9 133.065L132.324 140.247",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M105.512 105.296L91.1484 124.926",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.706 100.508L134.718 122.053L149.329 145.089",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M148.603 144.556L132.324 140.726L134.239 122.053L114.609 119.659M148.603 144.556L152.912 163.707M148.603 144.556L159.136 159.398",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3059 195.307L97.8513 193.871",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.657 185.731L118.918 190.998",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M159.615 147.908L179.67 146.075L183.782 134.161L194.314 131.04L203.692 124.324L209.983 132.591L211.758 147.479L194.645 142.325L179.221 155.355L159.615 147.908Z",
    fill: "#121212"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M179.67 146.075L159.615 147.908L179.221 155.355M179.67 146.075L179.221 155.355M179.67 146.075L194.645 142.325M179.67 146.075L183.782 134.161M179.221 155.355L194.645 142.325M194.645 142.325L194.314 131.04M194.645 142.325L209.983 132.591M194.645 142.325L211.758 147.479L209.983 132.591M194.645 142.325L183.782 134.161M194.314 131.04L209.983 132.591M194.314 131.04L183.782 134.161M194.314 131.04L203.692 124.324L209.983 132.591",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.942 115.514L156.723 98.9866L153.39 82.3139L161.722 71.7368L182.11 69.5727L164.571 84.7661L163.983 110.866L154.827 116.308L140.942 115.514Z",
    fill: "#121212"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M156.723 98.9866L140.942 115.514L154.827 116.308M156.723 98.9866L163.983 110.866M156.723 98.9866L164.571 84.7661M156.723 98.9866L154.827 116.308M156.723 98.9866L153.39 82.3139M163.983 110.866L164.571 84.7661M163.983 110.866L154.827 116.308M164.571 84.7661L161.722 71.7368M164.571 84.7661L182.11 69.5727L161.722 71.7368M164.571 84.7661L153.39 82.3139M161.722 71.7368L153.39 82.3139",
    stroke: "#E6007A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftKusama);
export default __webpack_public_path__ + "static/media/Gift_Kusama.ad78a296b5f94e413d81f29414aafc04.svg";
export { ForwardRef as ReactComponent };